export { analytics } from "@/lib/analytics/analytics.facade";
export type { UseAxReturn } from "@/lib/analytics/analytics.hooks";
export { useAx } from "@/lib/analytics/analytics.hooks";
export type { AnalyticsTraits, EventProperties } from "@/lib/analytics/analytics.types";
